import { ReactNode } from "react";

export function ModalSectionLayout({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex-1 flex flex-col min-w-0 min-h-0">
      <div className="p-5 pb-4 shrink-0">
        <h2 className="text-md font-medium">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
        )}
      </div>
      <div className="flex-1 overflow-y-auto p-5 pt-0">{children}</div>
      {footer && (
        <div className="border-t border-border p-5 pt-4 shrink-0">{footer}</div>
      )}
    </div>
  );
}
